<template>
    <b-modal :title="t('Error')" header-bg-variant="warning" header-text-variant="dark" ok-only :model-value="errors.length > 0" @ok="errors.shift()" no-close-on-backdrop no-close-on-esc>
        <div v-if="errors.length > 0">
            <div v-if="errors[0].response.data.validation_errors instanceof Object">
                <p>{{t('Correct the following issues:')}}</p>
                <b-table :items="Object.entries(errors[0].response.data.validation_errors)" :fields="['field', 'problem']">
                    <template v-slot:cell(field)="data">
                        {{data.item[0]}}
                    </template>
                    <template v-slot:cell(problem)="data">
                        <span v-if="data.item[1] instanceof Object && Object.entries(data.item[1]).length > 0">
                            {{Object.entries(data.item[1])[0][1]}}
                        </span>
                        <span v-else>{{data.item[1]}}</span>
                    </template>
                </b-table>
            </div>
            <div v-else>
                <p>{{t('HTTP code:')}} {{ errors[0].response.status }}</p>
                <p><code>{{ JSON.stringify(errors[0].response.data) }}</code></p>
            </div>
        </div>
    </b-modal>
</template>

<script setup>
import Api, {isSessionExpired} from "../../services/Api";
import {BModal, BTable} from 'bootstrap-vue-next';
import {ref} from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const errors = ref([]);

Api.interceptors.response.use(null, error => {
    // An expired session already navigates to the login page in Api.js, so it
    // must not raise a technical error dialog here.
    if (!isSessionExpired(error)) {
        errors.value.push(error);
    }
    return Promise.reject(error);
});
</script>

<style scoped>

</style>
